export default __webpack_public_path__ + "static/media/1.9f64b4b7.svg";